export const sumAndClearMeasures = (name: string): { total: number; count: number } => {
  const entries = performance.getEntriesByName(name);
  const count = entries.length;
  const total = entries.reduce((t, e) => t + e.duration, 0);
  performance.clearMeasures(name);
  return { total, count };
};
